import {
	type CompactType,
	type Layout,
	type LayoutItem,
	compactItem as rglCompactItem,
	// biome-ignore lint/style/noRestrictedImports: encapsulation
} from "react-grid-layout/build/utils";

// biome-ignore lint/style/noRestrictedImports: re-export
// biome-ignore lint/performance/noBarrelFile: re-export
export { bottom } from "react-grid-layout/build/utils";

export interface CompactItemParams {
	layout: Layout;
	item: LayoutItem;
	cols: number;
	compactType?: CompactType;
}

/**
 * Given a layout of items, compact a new item into the layout
 * such that there are no gaps between itself and the existing items.
 * @param {Object[]} config
 * @param {Layout} config[].layout - The existing layout of items
 * @param {LayoutItem} config[].item - The new item to be added to the layout
 * @param {number} config[].cols - The number of columns in the layout
 * @param {CompactType} [config[].compactType="vertical"] - The compact type to use, either "vertical" or "horizontal"
 * @returns A new item with its x and y positions adjusted to fit into the layout.
 */
export function compactItem({ layout, item, cols, compactType = "vertical" }: CompactItemParams): LayoutItem {
	return rglCompactItem(layout, item, compactType, cols, layout);
}
